import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { useTranslation } from "react-i18next";
import { changeForm } from "../../../searchFlightsSlice";
import React from "react";

function ExcludeCodeShareInputSFO() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const excludeCodeShare = useAppSelector(
    (state) => !state.searchFlights.form.includeCodeShare
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);
  const onChange = () =>
    dispatch(changeForm({ includeCodeShare: excludeCodeShare }));

  return (
    <div className="search-bar-item column p-0 checkbox-item">
      <label
        className="checkbox"
        title={t("CHECKBOX_SFO_TITLE_EXCLUDE_CODESHARE")}
        htmlFor="sfo-exclude-code-share"
      >
        {t("CHECKBOX_SFO_EXCLUDE_CODESHARE_FLIGHTS")}
      </label>
      <input
        type="checkbox"
        checked={excludeCodeShare}
        disabled={disabled}
        onChange={onChange}
        id="sfo-exclude-code-share"
      />
    </div>
  );
}

export default ExcludeCodeShareInputSFO;
